import React, { Fragment } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import {
  Button,
  List,
  Popover,
  usePopoverOpen,
  Icon,
  zIndex,
  colors,
} from '@spaceshipapp/cambridge';
import rgba from 'polished/lib/color/rgba';
import { User } from '../../contexts/types';
import logo from '../../assets/images/logo.svg';

export const NAVBAR_WIDTH = '236px';

interface NavbarProps {
  isAuthenticated: boolean;
  user?: User;
}

const NavbarDesktop: React.FC<NavbarProps> = (props) => {
  const { isAuthenticated } = props;

  return (
    <Navbar>
      <Logo>
        <Link to="/">
          <img src={logo} alt="Spaceship Pro" height={28} width={195} />
        </Link>
      </Logo>
      {isAuthenticated && (
        <UL>
          <li>
            <NavLink to="/orders">
              <Icon.Menu className={iconStyle} width={24} height={24} />
              Orders
            </NavLink>
          </li>
          <li>
            <NavLink to="/shipments">
              <Icon.Flight className={iconStyle} width={24} height={24} />
              Shipments
            </NavLink>
          </li>
          <li>
            <NavLink to="/settings">
              <Icon.Settings className={iconStyle} width={24} height={24} />
              Settings
            </NavLink>
          </li>
        </UL>
      )}
      <BtnGroup>
        <Popover
          trigger={<Button iconName="Person" variant="link" size="sm" aria-label="Profile" />}
        >
          <Dropdown isAuthenticated={isAuthenticated} />
        </Popover>
      </BtnGroup>
    </Navbar>
  );
};

const Dropdown: React.FC<NavbarProps> = (props) => {
  const { isAuthenticated } = props;
  const togglePopover = usePopoverOpen();

  const handleClose = () => {
    togglePopover(false);
  };

  return (
    <Menu onClick={handleClose}>
      <List>
        {isAuthenticated ? (
          <Fragment>
            <Item>
              <Link to="/logout">Sign Out</Link>
            </Item>
          </Fragment>
        ) : (
          <Fragment>
            <Item>
              <Link to="/login">Sign In</Link>
            </Item>
          </Fragment>
        )}
      </List>
    </Menu>
  );
};

const Navbar = styled.header`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${NAVBAR_WIDTH};
  padding: 1rem;
  background-color: ${colors.text};
  color: #fff;
  z-index: ${zIndex.HEADER};
`;

const Logo = styled.div`
  display: flex;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const UL = styled.ul`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2rem;
  margin-top: 4rem;
  margin-bottom: auto;

  a {
    color: ${colors.surface};
    font-weight: 500;
    text-decoration: none;
    opacity: 0.6;

    &.active {
      opacity: 1;
    }
  }

  svg {
    display: inline-block;
  }
`;

const BtnGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: auto;
  align-self: flex-end;

  button {
    color: ${colors.surface};
  }
`;

const Item = styled.li`
  display: flex;
  cursor: default;

  > * {
    display: block;
    width: 100%;
    padding: 1em;
    text-decoration: none;
  }
`;

const Menu = styled.div`
  border: solid 1px ${colors.border};
  border-radius: 0.25rem;
  box-shadow: 0 0.25em 0.75em ${rgba(colors.text, 0.08)};
  background-color: ${colors.surface};
  width: max(320px, 100%);
`;

const iconStyle = css`
  margin-right: 1rem;
`;

export default NavbarDesktop;
